import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { OrganizationProperty } from './organization-property';
export { OrganizationProperty };
import { organizationPropertySchema } from '@schemas/business-objects/organization-property';
import { OrganizationPropertyValueFormArray } from './organization-property-value-form-group';

export class OrganizationPropertyFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    type: SchemaFormControl;
    validValues: SchemaFormControl;
    sequence: SchemaFormControl;
    organizationPropertyValues: OrganizationPropertyValueFormArray;
  };

  declare value: Partial<OrganizationProperty>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(organizationPropertySchema, OrganizationProperty, data, options);
  }

  get object(): OrganizationProperty {
    return new OrganizationProperty(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'organizationPropertyValues':
        return new OrganizationPropertyValueFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<OrganizationProperty[]> {
    return OrganizationProperty.find(filter);
  }

  static async findOne(filter?: any): Promise<OrganizationProperty | null> {
    return OrganizationProperty.findOne(filter);
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<OrganizationProperty> {
    return OrganizationProperty.findById(id, filter);
  }

  static async create(
    data: Partial<OrganizationProperty>,
  ): Promise<OrganizationProperty> {
    return OrganizationProperty.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<OrganizationProperty>,
  ): Promise<OrganizationProperty> {
    return OrganizationProperty.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return OrganizationProperty.deleteById(id);
  }
}

export class OrganizationPropertyFormArray extends PersistedFormArray {
  readonly entityName = 'OrganizationProperty' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(organizationPropertySchema, OrganizationProperty, options);
  }

  protected override createItemGroup() {
    return new OrganizationPropertyFormGroup();
  }

  get array(): OrganizationProperty[] {
    return this.controls.map(
      (group: OrganizationPropertyFormGroup) => group.object,
    );
  }
}

export class OrganizationPropertyPersistedArray extends PersistedArray<OrganizationProperty> {
  readonly entityName = 'OrganizationProperty' as const;

  constructor(options?: PersistedArrayOptions) {
    super(OrganizationProperty, options);
  }
}
